import React, { useEffect, useState } from "react";
import styles from "./CreateStaffModal.module.css";
import CustomSelect from "../../../customComponents/CustomSelect";
import axios from "axios";
import { FiCopy } from "react-icons/fi";
import { API_URL } from '../../../config/api';

const CreateStaffModal = ({ onClose, onCreated, user, isEdit = false }) => {
  const [warehouses, setWarehouses] = useState([]);
  const [positions, setPositions] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [selectedPosition, setSelectedPosition] = useState("");
  const [form, setForm] = useState({
    phone: "",
    name: "",
    surname: "",
  });

  const [tempPassword, setTempPassword] = useState(null); // для отображения пароля после создания

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (isEdit && user) {
      setForm({
        name: user.name || "",
        surname: user.surname || "",
        phone: user.phone || "",
      });
      setSelectedPosition(user.role);
      setSelectedWarehouse(user.storages);
    }
  }, [isEdit, user]);

  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        const res = await fetch(`${API_URL}/api/storages?status=active`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (data?.data) {
          setWarehouses(data.data);
          localStorage.setItem("warehouses", JSON.stringify(data.data));
        }
      } catch (error) {
        console.error(error);
        const saved = localStorage.getItem("warehouses");
        if (saved) setWarehouses(JSON.parse(saved));
      }
    };
    fetchWarehouses();
  }, [token]);

  useEffect(() => {
    const fetchPositions = async () => {
      try {
        const res = await fetch(`${API_URL}/api/roles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (data?.data) {
          const filtered = data.data.filter((role) => role.type !== "owner");
          setPositions(filtered);
          localStorage.setItem("positions", JSON.stringify(filtered));
        }
      } catch (error) {
        console.error(error);
        const saved = localStorage.getItem("positions");
        if (saved) {
          const filtered = JSON.parse(saved).filter((role) => role.type !== "owner");
          setPositions(filtered);
        }
      }
    };
    fetchPositions();
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.surname || !form.phone || !selectedPosition || !selectedWarehouse) {
      alert("Пожалуйста, заполните все обязательные поля");
      return;
    }

    const role = positions.find((p) => p.title === selectedPosition);
    const warehouseObj = warehouses.find((w) => w.name === selectedWarehouse);

    if (!role || !warehouseObj) {
      alert("Ошибка: неверно выбрана должность или склад");
      return;
    }

    const payload = {
      role_id: role.id,
      surname: form.surname,
      name: form.name,
      phone: form.phone.replace(/\D/g, ""),
      storages: [warehouseObj.id],
    };

    try {
      let res;
      if (isEdit && user?.id) {
        res = await axios.put(`${API_URL}/api/users/${user.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        res = await axios.post(`${API_URL}/api/users`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      if (!isEdit) {
        // показываем временный пароль
        setTempPassword(res.data.data.password);
      }

      if (onCreated) onCreated(res.data.data);
      if (isEdit) onClose();
    } catch (error) {
      console.error(error);
      alert(`Ошибка: ${error.response?.data?.errors?.message || error.message}`);
    }
  };

  const handleCopy = () => {
    if (tempPassword) navigator.clipboard.writeText(tempPassword);
    alert("Пароль скопирован!");
  };

  const handleCloseTempPassword = () => {
    setTempPassword(null);
    onClose();
  };

  return (
    <>
      <div className={styles.overlay}>
        <div className={styles.modal}>
          <button className={styles.close} onClick={onClose}>×</button>
          <h2 className={styles.title}>{isEdit ? "Редактирование пользователя" : "Создание сотрудника"}</h2>

          <form className={styles.form} onSubmit={handleSubmit}>
            <label className={styles.label}>Фамилия</label>
            <input
              type="text"
              name="surname"
              className={styles.input}
              placeholder="Введите фамилию"
              value={form.surname}
              onChange={handleChange}
            />

            <label className={styles.label}>Имя</label>
            <input
              type="text"
              name="name"
              className={styles.input}
              placeholder="Введите имя"
              value={form.name}
              onChange={handleChange}
            />

            <label className={styles.label}>Номер телефона</label>
            <input
              type="tel"
              name="phone"
              placeholder="+7 700 000 00 00"
              className={styles.input}
              value={form.phone}
              onChange={handleChange}
            />

            <label className={styles.label}>Должность</label>
            <CustomSelect
              className={styles.select}
              options={positions.map((p) => p.title)}
              value={selectedPosition}
              onChange={setSelectedPosition}
              placeholder="Выберите должность"
            />

            <label className={styles.label}>Склад</label>
            <CustomSelect
              className={styles.select}
              options={warehouses.map((w) => w.name)}
              value={selectedWarehouse}
              onChange={setSelectedWarehouse}
              placeholder="Выберите склад"
            />

            <button type="submit" className={styles.submitBtn}>
              {isEdit ? "Сохранить изменения" : "Создать сотрудника"}
            </button>
          </form>
        </div>
      </div>

      {tempPassword && (
        <div className={styles.tempPasswordBox}>
          <span>Временный пароль: {tempPassword}</span>
          <button onClick={handleCopy} className={styles.copyBtn}><FiCopy /></button>
          <button onClick={handleCloseTempPassword} className={styles.okBtn}>OK</button>
        </div>
      )}
    </>
  );
};

export default CreateStaffModal;
